<template lang="pug">
footer#footer.footer.is-fixed
  .container
    .columns.signet.has-text-centered
      .column
        router-link(to="/"): i.signet
    hr.is-invisible
    .columns.has-text-centered-mobile
      .column
        ul.menu-horizontal
          li
            i.fa.fa-globe
          li
            a(@click="changeLanguage('de')" :class="{'is-active': locale === 'de'}") Deutsch
          li
            a(@click="changeLanguage('en')" :class="{'is-active': locale === 'en'}") English
          li
            a(@click="changeLanguage('fr')" :class="{'is-active': locale === 'fr'}") Français
      .column.has-text-centered-mobile.has-text-right-desktop
        ul.menu-horizontal
          <!-- li
            router-link(to="/manual") {{ $t("footerNav.help") }} -->
          li
            router-link(to="/privacy") {{ $t("footerNav.privacy") }}
          li
            router-link(to="/ueber") {{ $t("footerNav.imprint") }}
          li
            router-link(to="/ueber#koop") {{ $t("footerNav.partners") }}
    .columns.copyright.has-text-centered
      .column
          span.is-block-touch &copy; {{ currentYear }}
          span.is-block-touch {{ $t("footerNav.disclaimer") }}
          span.is-block-touch
            strong Hamburger Stiftung zur Förderung von Wissenschaft und Kultur
</template>

<script>
const { messages } = require("../../i18n/footer-nav");
const { mapMutations, mapState } = require("vuex");

export default {
    name: "FooterNav",
    i18n: { messages },

    data() {
        return {
            currentYear: new Date().getFullYear(),
        };
    },

    computed: {
        ...mapState("i18n", ["locale"]),
    },

    methods: {
        changeLanguage(lang) {
            this.setLocale(lang);
            this.$i18n.locale = lang;
        },

        ...mapMutations("i18n", ["setLocale"]),
    },
};
</script>
